import { RouterProvider } from "react-router/dom";

import { routerConfig } from "./routes";

const ChillnnRouterProvider = () => {
	return <RouterProvider router={routerConfig} />;
};

export { ChillnnRouterProvider as RouterProvider };
